import { render, staticRenderFns } from "./MonitoringHeaderComplaint.vue?vue&type=template&id=73e18d4f"
import script from "./MonitoringHeaderComplaint.vue?vue&type=script&lang=js"
export * from "./MonitoringHeaderComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports